import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
export const settingsParams = createSettingsParams({
    channelId: {
        type: SettingsParamType.String,
        getDefaultValue: () => 'a1ca9dac-7ee4-4d52-a418-68329471105b',
    },
    videoId: {
        type: SettingsParamType.String,
        getDefaultValue: () => '',
    },
    useIdsFromSettings: {
        type: SettingsParamType.Boolean,
        getDefaultValue: () => false,
    },
});
//# sourceMappingURL=settingsParams.js.map